const superadministrador = [
  {
    action: 'access',
    subject: 'all'
  },

  {
    action: 'create',
    subject: 'all'
  },

  {
    action: 'delete',
    subject: 'all'
  },

  {
    action: 'read',
    subject: 'all'
  },

  {
    action: 'update',
    subject: 'all'
  }
]

export default superadministrador
